import { transformPlacementsToBE } from '../../../placements/helpers'
import { formatShowTargetToBE } from '../../../formatters/geolocationsFormatters'
import { formatInterestsToBE } from '../../../formatters'

import {
  AGE_OPTION,
  ANYONE_OVER_18,
  BIDDING_TYPE,
  DESTINATION_TYPE,
  ENGAGEMENT_TYPE,
  GEN_Z,
  IS_SPEND_LIFETIME,
  LANGUAGES_OPTION,
  MILLENNIALS,
  OBJECTIVE,
  ON_PAGE,
  ON_POST,
  ON_VIDEO,
  OPTIMIZATION_TYPE,
  SELECT_LANGUAGES,
  SPEND_OPTION,
  STOP_OPTION,
  STOP_OPTION_INDEFINITELY,
  THRUPLAY,
  WEBSITE
} from './fields'
import {
  LOCATION_LIST,
  SHOW_COUNTRIES,
  SHOW_OPTION,
  SHOW_OPTION_LOCATION_LIST,
  SHOW_REGIONS
} from '../../../../ReusableFormFields/GeolocationsFields/fields'
import {
  AGE,
  PLACEMENT_POSITIONS,
  placementSafetyRules,
  recentLocationTypes,
  STOP_DATE,
  STOP_TIME,
  targetingRelaxationTypes
} from '../../../../Multiplatform/LineItemForms/fields'
import { OPTION_CUSTOM, OPTION_NO, OPTION_YES } from '../../../../../constants/forms'
import {
  CONVERSIONS,
  COST_CAP,
  LANDING_PAGE_VIEWS,
  MANUAL,
  MINIMUM_ROAS,
  OUTCOME_AWARENESS,
  OUTCOME_ENGAGEMENT,
  OUTCOME_LEADS,
  OUTCOME_SALES,
  OUTCOME_TRAFFIC,
  POST_ENGAGEMENT,
  REACH
} from '../../../../../constants/campaigns'
// import {
//   formatScheduleToBE,
//   SCHEDULE_DATES,
//   SCHEDULE_FRIDAY,
//   SCHEDULE_MONDAY,
//   SCHEDULE_OPTION,
//   SCHEDULE_SATURDAY,
//   SCHEDULE_SUNDAY,
//   SCHEDULE_THURSDAY,
//   SCHEDULE_TUESDAY,
//   SCHEDULE_WEATHER_DAYS,
//   SCHEDULE_WEATHER_LOCATION,
//   SCHEDULE_WEATHER_TEMPERATURE,
//   SCHEDULE_WEDNESDAY
// } from '../../../../features/components/FormFields/ScheduleFields/fields'
import { GEO_TARGETING } from '../../LineItemFacebookEdit/fields'
import {
  formatTimeStartToBE,
  START_DATE,
  START_OPTION,
  START_TIME
} from '../../../../ReusableFormFields/StartTimeFields/fields'
import { formatTimeStopToBE } from '../../../../ReusableFormFields/StopTimeFields/fields'
import {
  AUDIENCES_OPTION,
  CUSTOM_AUDIENCES_EXCLUSION_CHECKED
} from '../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { PROMOTED_PIXEL } from '../../../../../constants/selectLists/customEventTypes/fields'
import { INTERESTS_OPTION } from '../../../../ReusableFormFields/InterestsFields/fields'
import {
  GENDER_OPTION_ALL,
  GENDER_OPTION_FEMALES,
  GENDER_OPTION_MALES
} from '../../../../ReusableFormFields/GenderFields/fields'
import {
  FREQUENCY_OPTION,
  FREQUENCY_OPTION_AUTOMATIC,
  FREQUENCY_OPTION_DEFAULT
} from '../../../../ReusableFormFields/FrequencyFields/fields'
import {
  AUDIENCE_NETWORK_CLASSIC,
  AUDIENCE_NETWORK_INSTREAM_VIDEO,
  AUDIENCE_NETWORK_REWARDED_VIDEO,
  FACEBOOK_FEED,
  FACEBOOK_INSTANT_ARTICLE,
  FACEBOOK_INSTREAM_VIDEO,
  FACEBOOK_MARKETPLACE,
  FACEBOOK_RIGHT_HAND_COLUMN,
  FACEBOOK_SEARCH,
  FACEBOOK_STORY,
  FACEBOOK_VIDEO_FEEDS,
  INSTAGRAM_EXPLORE,
  INSTAGRAM_REELS,
  INSTAGRAM_STORY,
  INSTAGRAM_STREAM,
  MESSENGER_MESSENGER_HOME,
  MESSENGER_SPONSORED_MESSAGES,
  MESSENGER_STORY
} from '../../../placements/fields'
import { AGE_MAX, AGE_MIN, FEMALE, GENDER, MALE } from '../../../fields'
import { eventTypes } from '../../../../../constants/selectLists/customEventTypes'
import { BUDGET_DAILY, BUDGET_LIFETIME, BUDGET_OPTION } from '../../../../Multiplatform/fields'
import { PAGE_LIKES } from '../../../../../constants/reusableObjectives'

export const formatSpendValuesToBE = (
  isSpendLifetime,
  min_spend_target_lifetime,
  spend_cap_lifetime,
  min_spend_target_daily,
  spend_cap_daily
) => {
  return isSpendLifetime
    ? {
        ...(min_spend_target_lifetime && { min_spend_target_lifetime }),
        ...(spend_cap_lifetime && { spend_cap_lifetime })
      }
    : {
        ...(min_spend_target_daily && { min_spend_target_daily }),
        ...(spend_cap_daily && { spend_cap_daily })
      }
}

export const formatGenderToBE = gender_option => {
  switch (gender_option) {
    case GENDER_OPTION_ALL:
      return {
        [MALE]: true,
        [FEMALE]: true
      }
    case GENDER_OPTION_MALES:
      return {
        [MALE]: true,
        [FEMALE]: false
      }
    case GENDER_OPTION_FEMALES:
      return {
        [MALE]: false,
        [FEMALE]: true
      }
    default:
      return {}
  }
}

export const formatAgeToBE = ({ ageOption, ageMin, ageMax }) => {
  switch (ageOption) {
    case ANYONE_OVER_18:
      return {
        [AGE_MIN]: 18,
        [AGE_MAX]: 65
      }
    case MILLENNIALS:
      const minAgeMillennials = new Date().getFullYear() - 1994
      const maxAgeMillennials = new Date().getFullYear() - 1980

      return {
        [AGE_MIN]: minAgeMillennials,
        [AGE_MAX]: maxAgeMillennials
      }
    case GEN_Z:
      const maxAgeZ = new Date().getFullYear() - 1995

      return {
        [AGE_MIN]: 18,
        [AGE_MAX]: maxAgeZ
      }
    case OPTION_CUSTOM:
      return {
        ...(ageMin >= 18 && { [AGE_MIN]: ageMin }),
        ...(ageMax >= 18 && { [AGE_MAX]: ageMax })
      }
    default: {
      return {}
    }
  }
}

export const formatLanguagesToBE = languages => {
  return languages.map(item => item.value)
}

export const formatFrequencyToBE = (frequency_option, frequency_impressions, frequency_days) => {
  switch (frequency_option) {
    case FREQUENCY_OPTION_DEFAULT:
      return {
        impressions: 2,
        event: 'impressions',
        days: 7
      }
    case OPTION_CUSTOM:
      return {
        impressions: Number(frequency_impressions),
        event: 'impressions',
        days: Number(frequency_days)
      }
    default:
      return {}
  }
}

export const formatAudiencesToBE = audiences => {
  return audiences.map(item => ({
    id: item.value
  }))
}

const getDestinationType = engagementType => {
  switch (engagementType) {
    case THRUPLAY:
      return ON_VIDEO
    case PAGE_LIKES:
      return ON_PAGE
    case POST_ENGAGEMENT:
    default:
      return ON_POST
  }
}

const formatOptimizationValuesToBE = ({ campaignObjective, optimizationType, engagementType }) => {
  switch (campaignObjective) {
    case OUTCOME_ENGAGEMENT:
      return {
        [OBJECTIVE]: engagementType,
        [DESTINATION_TYPE]: getDestinationType(engagementType)
      }
    case OUTCOME_TRAFFIC:
      return {
        [OBJECTIVE]: LANDING_PAGE_VIEWS,
        [DESTINATION_TYPE]: WEBSITE
      }
    case OUTCOME_AWARENESS:
      return {
        [OBJECTIVE]: optimizationType
      }
    default:
      return {}
  }
}

export const transformValuesToBE = (
  values,
  includeValuesInRequest,
  isCampaignBudgetExist,
  selectedAdAccountId,
  selectedAdAccountTimezone,
  campaignId,
  campaignObjective,
  campaignBiddingType
) => {
  const {
    // todo need to refactor values destructuring here, because we lose constants benefits
    // RECOMMENDED SETUP
    recommended_setup_option,
    // START TIME
    [START_OPTION]: startOption,
    [START_DATE]: startDate,
    [START_TIME]: startTime,
    // STOP TIME
    [STOP_OPTION]: stopOption,
    [STOP_DATE]: stopDate,
    [STOP_TIME]: stopTime,
    // SCHEDULE
    schedule_option,
    schedule_monday,
    schedule_tuesday,
    schedule_wednesday,
    schedule_thursday,
    schedule_friday,
    schedule_saturday,
    schedule_sunday,
    schedule_dates,
    schedule_weather_location,
    schedule_weather_temperature,
    schedule_weather_days,
    // BUDGET
    budget_option,
    budget_lifetime,
    budget_daily,
    // SPEND
    spend_option,
    min_spend_target_lifetime,
    spend_cap_lifetime,
    min_spend_target_daily,
    spend_cap_daily,
    // GEOLOCATIONS
    show_option,
    show_countries,
    show_country_choice,
    show_regions,
    [LOCATION_LIST]: locationList,
    // GENDER
    gender_option,
    // AGE
    age_option,
    min_age_years,
    max_age_years,
    min_age_choice,
    max_age_choice,
    // INTERESTS,
    interests_option,
    interests,
    // LANGUAGES
    languages_option,
    languages,
    // FREQUENCY
    frequency_option,
    frequency_days,
    frequency_impressions,
    // AUDIENCES
    audiences_option,
    custom_audiences,
    custom_audiences_exclusions_checked,
    custom_audiences_exclusions,
    // BIDDING TYPE
    [BIDDING_TYPE]: lineItemBiddingType,
    // TARGET COST CAP
    target_cost_cap,
    roas_average_floor,
    objective,
    // PROMOTED OBJECT,
    promoted_pixel,
    custom_event_type,
    // PLACEMENT
    [FACEBOOK_FEED]: facebookFeed,
    [INSTAGRAM_STREAM]: instagramStream,
    [FACEBOOK_MARKETPLACE]: facebookMarketplace,
    [FACEBOOK_VIDEO_FEEDS]: facebookVideoFeeds,
    [FACEBOOK_RIGHT_HAND_COLUMN]: facebookRightHandColumn,
    [INSTAGRAM_EXPLORE]: instagramExplore,
    [MESSENGER_MESSENGER_HOME]: messengerHome,
    [INSTAGRAM_STORY]: instagramStory,
    [FACEBOOK_STORY]: facebookStory,
    [MESSENGER_STORY]: messengerStory,
    [INSTAGRAM_REELS]: instagramReels,
    [FACEBOOK_INSTREAM_VIDEO]: facebookInstreamVideo,
    [AUDIENCE_NETWORK_INSTREAM_VIDEO]: audienceNetworkInstreamVideo,
    [FACEBOOK_SEARCH]: facebookSearch,
    [MESSENGER_SPONSORED_MESSAGES]: messengerSponsoredMessages,
    [FACEBOOK_INSTANT_ARTICLE]: facebookInstantArticle,
    [AUDIENCE_NETWORK_CLASSIC]: audienceNetworkClassic,
    [AUDIENCE_NETWORK_REWARDED_VIDEO]: audienceNetworkRewardedVideo,
    [PLACEMENT_POSITIONS]: placementPositions,

    //ENGAGEMENT_TYPE
    [ENGAGEMENT_TYPE]: engagementType,
    [OPTIMIZATION_TYPE]: optimizationType,

    ...purifiedValues
  } = values

  const formattedTimeStart = formatTimeStartToBE({ startOption, startDate, startTime })

  // BUDGET
  const includeBudget = includeValuesInRequest[BUDGET_OPTION]

  // SPEND
  const includeSpend = includeValuesInRequest[SPEND_OPTION]
  const isSpendLifetime = includeValuesInRequest[IS_SPEND_LIFETIME]
  const spendValues = formatSpendValuesToBE(
    isSpendLifetime,
    min_spend_target_lifetime,
    spend_cap_lifetime,
    min_spend_target_daily,
    spend_cap_daily
  )

  // PROMOTED OBJECT
  const includePromotedObject = includeValuesInRequest[PROMOTED_PIXEL]

  const isCampaignObjectiveConversionsOrSales = campaignObjective === CONVERSIONS || campaignObjective === OUTCOME_SALES

  // if campaign is conversions and doesn't have own bidding type,
  // use line item bidding type value selected on BiddingTypeStep
  const biddingTypeValue =
    isCampaignObjectiveConversionsOrSales && !campaignBiddingType ? lineItemBiddingType : campaignBiddingType

  return {
    // todo think about removing, because sending formik values may lead to bugs
    ...purifiedValues,
    account: selectedAdAccountId,
    campaign_id: campaignId,
    campaign_objective: campaignObjective,
    ...(isCampaignObjectiveConversionsOrSales && !campaignBiddingType && { bidding_type: lineItemBiddingType }),
    ...(!isCampaignObjectiveConversionsOrSales && { bidding_type: 'automatic' }),
    time_start: formattedTimeStart,
    ...(values[STOP_OPTION] !== STOP_OPTION_INDEFINITELY && {
      time_stop: formatTimeStopToBE({ stopOption, stopDate, stopTime, timeStart: formattedTimeStart })
    }),
    // schedule is hidden
    pacing: ['standard'],
    // ...formatScheduleToBE({
    //   schedule_option: values[SCHEDULE_OPTION],
    //   schedule_monday: values[SCHEDULE_MONDAY],
    //   schedule_tuesday: values[SCHEDULE_TUESDAY],
    //   schedule_wednesday: values[SCHEDULE_WEDNESDAY],
    //   schedule_thursday: values[SCHEDULE_THURSDAY],
    //   schedule_friday: values[SCHEDULE_FRIDAY],
    //   schedule_saturday: values[SCHEDULE_SATURDAY],
    //   schedule_sunday: values[SCHEDULE_SUNDAY],
    //   schedule_dates: values[SCHEDULE_DATES],
    //   schedule_weather_location: values[SCHEDULE_WEATHER_LOCATION],
    //   schedule_weather_temperature: values[SCHEDULE_WEATHER_TEMPERATURE],
    //   schedule_weather_days: values[SCHEDULE_WEATHER_DAYS],
    //   selectedAdAccountTimezone
    // }),
    ...(includeBudget && values[BUDGET_OPTION] === BUDGET_LIFETIME && { budget_lifetime }),
    ...(includeBudget && values[BUDGET_OPTION] === BUDGET_DAILY && { budget_daily }),
    ...(includeSpend && values[SPEND_OPTION] === OPTION_CUSTOM && spendValues),
    // GEO_LOCATION
    ...(show_option === SHOW_OPTION_LOCATION_LIST && { [LOCATION_LIST]: locationList }),
    // GEO_TARGETING could be send within LOCATION_LIST
    [GEO_TARGETING]: {
      ...recentLocationTypes,
      ...formatShowTargetToBE({
        geotargetingOption: values[SHOW_OPTION],
        countries: values[SHOW_COUNTRIES],
        regions: values[SHOW_REGIONS]
      })
    },
    // todo remove hardcoded value when create step for this field
    billing_event: 'impressions',
    [GENDER]: formatGenderToBE(gender_option),
    [AGE]: formatAgeToBE({
      ageOption: values[AGE_OPTION],
      ageMin: values[AGE_MIN],
      ageMax: values[AGE_MAX]
    }),
    ...(values[INTERESTS_OPTION] !== OPTION_NO && { interests: formatInterestsToBE(interests) }),
    ...(values[LANGUAGES_OPTION] === SELECT_LANGUAGES && { languages: formatLanguagesToBE(languages) }),
    ...(values[FREQUENCY_OPTION] !== FREQUENCY_OPTION_AUTOMATIC &&
      (campaignObjective === REACH || values[OPTIMIZATION_TYPE] === REACH) && {
        frequency: formatFrequencyToBE(frequency_option, frequency_impressions, frequency_days)
      }),
    ...(values[AUDIENCES_OPTION] === OPTION_YES && { custom_audiences: formatAudiencesToBE(custom_audiences) }),
    ...(values[CUSTOM_AUDIENCES_EXCLUSION_CHECKED] && {
      custom_audiences_exclusions: formatAudiencesToBE(custom_audiences_exclusions)
    }),
    ...((biddingTypeValue === MANUAL || biddingTypeValue === COST_CAP) && { target_cost_cap, objective }),
    ...(biddingTypeValue === MINIMUM_ROAS && { roas_average_floor, objective: 'value' }),
    ...(includePromotedObject && {
      promoted_object: {
        ...(promoted_pixel && { pixel_id: promoted_pixel }),
        // for OUTCOME_LEADS campaigns we don't show custom event type field, and just use 'lead' event
        custom_event_type: campaignObjective === OUTCOME_LEADS ? eventTypes.LEAD : custom_event_type
      }
    }),
    ...formatOptimizationValuesToBE({
      campaignObjective,
      optimizationType,
      engagementType
    }),
    // placements
    ...transformPlacementsToBE(placementPositions, campaignObjective),
    ...placementSafetyRules,
    ...targetingRelaxationTypes
  }
}
